const SMART_CONTRACT_PATH: string = '/smart-contracts';

export const SMART_CONTRACT_PATHS = {
    LANDING_PAGE: SMART_CONTRACT_PATH,
    CREATE_NEW_SMART_CONTRACT: `${SMART_CONTRACT_PATH}/new`,
    UPDATE_SMART_CONTRACT: `${SMART_CONTRACT_PATH}/:chain/:sdoId`,
    SMART_CONTRACT_RECEIPTS: `${SMART_CONTRACT_PATH}/receipt/:chain/:sdoId`,
    EXECUTE_SMART_CONTRACT: `${SMART_CONTRACT_PATH}/execute-smart-contract`,
};
